import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "Calculatrice de forme de visage";
const DESCRIPTION =
  "Calculatrice de forme de visage en francais pour estimer vos indicateurs de sante rapidement. Entrez vos donnees et obtenez un resultat clair avec des reperes utiles pour le suivi quotidien.";
const KEYWORDS =
  "de forme de visage, calculatrice de forme de visage, calcul en ligne, sante, bien-etre, indicateurs sante, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/face-shape-calculator/";

function FaceShapeCalculator() {
  const [sex, setSex] = useState("");
  const [foreheadWidth, setForeheadWidth] = useState();
  const [cheeksWidth, setCheeksWidth] = useState();
  const [jawlineLength, setJawlineLength] = useState();
  const [faceLength, setFaceLength] = useState();
  const [features, setFeatures] = useState("");
  const [result, setResult] = useState();
  const [error, setError] = useState("");

  const handleCalculate = () => {
    const minForeheadWidth = 7.62;
    const minCheeksWidth = 7.62;
    const minJawlineLength = 7.62;
    const minFaceLength = 12.7;

    if (
      foreheadWidth < minForeheadWidth ||
      cheeksWidth < minCheeksWidth ||
      jawlineLength < minJawlineLength ||
      faceLength < minFaceLength
    ) {
      setError(
        `Les valeurs saisies sont incorrectes. Veuillez vérifier les limites minimales des mesures, qui sont:\n
            1- Largeur minimale du front: ${minForeheadWidth} cm\n
            2- Largeur minimale des joues: ${minCheeksWidth} cm\n
            3- Longueur minimale de la mâchoire: ${minJawlineLength} cm\n
            4- Longueur minimale du visage: ${minFaceLength} cm`
      );
      return;
    }

    let faceShape = "Non déterminé";

    if (faceLength > cheeksWidth && foreheadWidth > jawlineLength) {
      faceShape = "Forme du visage: Ovale";
    } else if (faceLength > cheeksWidth && jawlineLength === foreheadWidth) {
      faceShape = "Forme du visage: Rectangle";
    } else if (
      faceLength === cheeksWidth &&
      foreheadWidth < cheeksWidth &&
      jawlineLength < cheeksWidth
    ) {
      faceShape = "Forme du visage: Rond";
    } else if (
      faceLength === cheeksWidth &&
      jawlineLength > cheeksWidth &&
      jawlineLength === foreheadWidth
    ) {
      faceShape = "Forme du visage: Carré";
    } else if (jawlineLength > cheeksWidth && cheeksWidth > foreheadWidth) {
      faceShape = "Forme du visage: Triangle";
    } else if (jawlineLength < cheeksWidth && foreheadWidth >= cheeksWidth) {
      faceShape = "Forme du visage: Cœur";
    } else if (
      jawlineLength < cheeksWidth &&
      foreheadWidth < cheeksWidth &&
      faceLength > foreheadWidth &&
      features === "acéré"
    ) {
      faceShape = "Forme du visage: Diamant";
    } else if (
      foreheadWidth === cheeksWidth &&
      faceLength === jawlineLength &&
      features === "acéré"
    ) {
      faceShape = "Forme du visage: Carré";
    } else if (
      ((foreheadWidth === cheeksWidth) === faceLength) === jawlineLength &&
      (features === "arrondi" || "moyen")
    ) {
      faceShape = "Forme du visage: Rectangle";
    } else if (
      foreheadWidth === cheeksWidth &&
      faceLength === jawlineLength &&
      (features === "arrondi" || "moyen")
    ) {
      faceShape = "Forme du visage: Triangle";
    } else if (
      ((foreheadWidth === cheeksWidth) === faceLength) === jawlineLength &&
      features === "acéré"
    ) {
      faceShape = "Forme du visage: Carré";
    }

    setResult(faceShape);
    setError("");
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Vous vous êtes déjà demandé quelle était la forme de votre visage? Est-ce ovale, carré, cœur, ou une autre forme? Maintenant, vous pouvez le découvrir avec précision en utilisant notre calculatrice intelligente de détermination de la forme du visage. Simplement, entrez les mesures de base de votre visage et choisissez une description de vos traits, et vous obtiendrez un résultat précis en quelques secondes.
                </p>
                <p>
                  Notre calculatrice analyse les données que vous saisissez, telles que la largeur du front, la largeur des joues, la longueur de la mâchoire et la longueur du visage, ainsi qu'une description de vos traits (acérés, arrondis ou d'intensité moyenne). Grâce à ces informations, la calculatrice peut déterminer la forme géométrique qui se rapproche le plus de votre forme de visage. Que vous soyez intéressé par la découverte de la forme de votre visage par simple curiosité, ou pour déterminer les coupes de cheveux ou les lunettes appropriées, notre calculatrice est l'outil parfait pour vous.
                </p>
                <p>
                  Pour déterminer la forme du visage, vous pouvez saisir les mesures requises et choisir une description de vos traits.
                </p>
                <ul>
                  <li>
                    Entrez le sexe, la largeur du front, la largeur des joues, la longueur de la mâchoire, la longueur du visage.
                  </li>
                  <li>Choisissez l'unité de mesure (cm ou pouces).</li>
                  <li>
                    Choisissez comment vous décrivez les traits de votre visage: acérés, arrondis ou d'intensité moyenne.
                  </li>
                </ul>
                <p>
                  Cette calculatrice a été développée sur la base d'études d'analyse de la forme du visage.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="ltr">
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="sex">
                        Sélectionnez le sexe
                      </label>
                      <select
                        id="sex"
                        value={sex}
                        onChange={(e) => setSex(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value="">-- Sélectionnez --</option>
                        <option value="male">Masculin</option>
                        <option value="female">Féminin</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="foreheadWidth">
                        Largeur du front (cm)
                      </label>
                      <input
                        id="foreheadWidth"
                        type="number"
                        value={foreheadWidth}
                        onChange={(e) => setForeheadWidth(e.target.value)}
                        placeholder="Entrez la largeur du front"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="cheeksWidth">
                        Largeur des joues (cm)
                      </label>
                      <input
                        id="cheeksWidth"
                        type="number"
                        value={cheeksWidth}
                        onChange={(e) => setCheeksWidth(e.target.value)}
                        placeholder="Entrez la largeur des joues"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="jawlineLength">
                        Longueur de la mâchoire (cm)
                      </label>
                      <input
                        id="jawlineLength"
                        type="number"
                        value={jawlineLength}
                        onChange={(e) => setJawlineLength(e.target.value)}
                        placeholder="Entrez la longueur de la mâchoire"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="faceLength">
                        Longueur du visage (cm)
                      </label>
                      <input
                        id="faceLength"
                        type="number"
                        value={faceLength}
                        onChange={(e) => setFaceLength(e.target.value)}
                        placeholder="Entrez la longueur du visage"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="features">
                        Sélectionnez les traits
                      </label>
                      <select
                        id="features"
                        value={features}
                        onChange={(e) => setFeatures(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value="">-- Sélectionnez --</option>
                        <option value="acéré">Acérés</option>
                        <option value="arrondi">Arrondis</option>
                        <option value="moyen">Moyen</option>
                      </select>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      Calculer
                    </button>
                  </div>
                  <br />
                  {error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur: {error}
                    </p>
                  )}
                  {result && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Résultat:</h4>
                      <p className="text-white">{result}</p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
  <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseils d'utilisation</h3></div>
              <div className="info-section-body">
                <p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Formes de visage</h3></div>
              <div className="info-section-body"><p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p></div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Utilit pratique</h3></div>
              <div className="info-section-body"><p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FaceShapeCalculator;
